<template>
  <div class="context">
    <div class="cardheard">
      <div>
        <el-input placeholder="请输入姓名/手机号" v-model="req.parma" />
      </div>
      <el-button type="primary" @click="selectByQuery">查询</el-button>
      <el-button type="primary" @click="clear">清空</el-button>
      <el-button type="primary" @click="modelShow=true">新增</el-button>
    </div>
    <template>
      <el-table v-model="Users" :data="Users" style="width: 100%" height="80%" v-loading="loading">
        <el-table-column type="index" width="50">
        </el-table-column>

        <el-table-column label="姓名">
          <template slot-scope="scope">
            <span>{{ scope.row.customName }}</span>
          </template>
        </el-table-column>

        <el-table-column label="手机号">
          <template slot-scope="scope">
            <span>{{ scope.row.customPhone }}</span>
          </template>
        </el-table-column>

      
        <el-table-column label="当前余额">
          <template slot-scope="scope">
            <span>{{ scope.row.customMoney }}</span>
          </template>
        </el-table-column>

        <el-table-column label="注册时间">
          <template slot-scope="scope">
            <span>{{ scope.row.createTime }}</span>
          </template>
        </el-table-column>

     

        <el-table-column label="操作" width="300">

          <template slot-scope="scope">
            <el-button type="text" @click="updateUser(scope.row)" size="small">查看</el-button>
            <el-button type="text" @click="cz(scope.row)" size="small">充值</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div slot="footer" class="dialog-footer">
        <div class="block">
          <el-pagination @current-change="handleCurrentChange" background layout="prev, pager, next" :total="10000">
          </el-pagination>
        </div>
      </div>


    </template>
    <template>
    </template>

    <div v-if="modelShow">
      <customUpdateorAdmin :dialogShow="modelShow" ref="userModel" @pushdata="pushdata"  @modelChange="userShowChange" />
    </div>

    <el-dialog
      title=""
      :visible.sync="czshow"
      width="60%"
      :close-on-click-modal="false"
    >
    <div slot="title" class="header-title">
          <span class="title-name">会员:{{this.info.customName}} 当前余额:{{this.info.customMoney}}</span>
    </div>
    <el-input type="number"   placeholder="请输入充值金额" v-model="changeMoney" />

    <div slot="footer" class="dialog-footer">
          <div>
            <el-button @click="czComfire()">确认充值</el-button>
          </div>
        </div>
   </el-dialog>
  </div>
</template>

<script>
import store from "@/store/";
import customUpdateorAdmin from "../components/customUpdateorAdmin.vue";

export default {
  data() {
    return {
      changeMoney: "",
      czshow: false,
      loading: true,
      req: {
        parma: "",
        pageIndex: 0,
        pageCount: 10,
      },
      Users: [],
      modelShow: false,
      info: "",
    };
  },
  mounted() {
    this.pushdata();
  },
  methods: {
    cz(row) {
      console.log(row);
      this.info = row;

      setTimeout(() => {
        this.czshow = true;
      }, 100);
    },
    czComfire() {
      const loading = this.$loading({
        lock: true,
        text: "办理中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      var that = this;
      that.$axios
        .post("/api2/business/addCustomMoney", {
          id: that.info.id,
          customMoney: that.changeMoney,
        })
        .then(function (response) {
          console.log(response.data.code);
          that.$message({
            type: "success",
            message: "操作成功",
          });
          loading.close();
          that.changeMoney = "";
          that.czshow = false;
          that.pushdata();
        });
    },
    reset() {
      this.req.pageIndex = 0;
      this.req.pageCount = 10;
    },
    clear() {
      this.req.parma = "";
      this.reset();
      this.pushdata();
    },
    selectByQuery() {
      this.req.pageIndex = 0;
      this.pushdata();
    },
    updateUser(row) {
      (this.modelShow = true),
        setTimeout(() => {
          this.$refs["userModel"].init(row.id); //用$refs赋值调用子组件的init方法
        }, 500);
    },
    userShowChange(visible) {
      this.modelShow = visible;
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      if (val != 1) {
        var statcount = (val - 1) * this.req.pageCount;
        this.req.pageIndex = statcount;
        console.log("当前开始index--" + statcount);
      } else {
        this.req.pageIndex = 0;
        console.log("当前开始index--" + statcount);
      }
      console.log(this.req);
      this.pushdata();
    },
    pushdata() {
      var that = this;
      that.$axios
        .post("/api2/business/showAllCustoms", this.req)
        .then(function (response) {
          that.loading = false;
          that.Users = response.data.data;
        });
    },
  },
  components: { customUpdateorAdmin },
};
</script>
<style scoped></style>
